<template>
  <TransitionGroup class="onfocus__queries-list q-list-group q-list-group-flush q-w-100 q-px-2" name="list" tag="ul">
    <QueriesItem v-for="(query, index) in queries" :key="query" :query-item="query" :index="index"
                 :can-remove="canRemove"/>
  </TransitionGroup>
</template>

<script lang="ts" setup>
import QueriesItem from './QueriesItem.vue'
import {defineProps} from "vue";

import {PropType} from 'vue';

defineProps({
  queries: Array as PropType<string[]>,
  canRemove: {
    type: Boolean as PropType<boolean>,
    default: false
  }
});


</script>

<style scoped>
a {
  cursor: pointer;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>